import { storageSet } from '../../utils/storage'
import { PRAXIS_REDIRECT_AFTERAUTH } from '../../constants'

export interface LoginParams<Url extends string = string> {
  redirect: Url
  loginUrl: Url
}

export const login = ({ redirect, loginUrl }: LoginParams): void => {
  // save current route
  if (redirect) {
    storageSet(PRAXIS_REDIRECT_AFTERAUTH, redirect)
  }
  // redirect to OAuth login page
  window.location.replace(loginUrl)
}

export type SaveSession = (
  accessToken: string,
  identityToken: string,
  setStorage: boolean,
  redirect: string,
) => Promise<void>
